import React from 'react';
import Header from "../header/Header";
import './AuthenticatedLayout.css';

function AuthenticatedLayout({ children }) {
    return (
        <div className="authenticated-container">
            <Header />
            <main className="main-content">
                {children}
            </main>
        </div>
    );
}

export default AuthenticatedLayout;